import k from "./extends.mjs";
import * as r from "react";
import { ariaHidden as S, ModalManager as $ } from "./ModalManager.mjs";
import A from "./useForkRef.mjs";
import H from "./useEventCallback.mjs";
import L from "./ownerDocument.mjs";
import { extractEventHandlers as N } from "./extractEventHandlers.mjs";
import w from "./createChainedFunction.mjs";
function j(o) {
  return typeof o == "function" ? o() : o;
}
function q(o) {
  return o ? o.props.hasOwnProperty("in") : !1;
}
const z = new $();
function ee(o) {
  const {
    container: D,
    disableEscapeKeyDown: M = !1,
    disableScrollLock: b = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = z,
    closeAfterTransition: p = !1,
    onTransitionEnter: h,
    onTransitionExited: C,
    children: i,
    onClose: d,
    open: l,
    rootRef: K
  } = o, m = r.useRef({}), E = r.useRef(null), a = r.useRef(null), T = A(a, K), [v, x] = r.useState(!l), g = q(i);
  let f = !0;
  (o["aria-hidden"] === "false" || o["aria-hidden"] === !1) && (f = !1);
  const B = () => L(E.current), u = () => (m.current.modalRef = a.current, m.current.mount = E.current, m.current), y = () => {
    s.mount(u(), {
      disableScrollLock: b
    }), a.current && (a.current.scrollTop = 0);
  }, P = H(() => {
    const n = j(D) || B().body;
    s.add(u(), n), a.current && y();
  }), R = r.useCallback(() => s.isTopModal(u()), [s]), _ = H((n) => {
    E.current = n, n && (l && R() ? y() : a.current && S(a.current, f));
  }), c = r.useCallback(() => {
    s.remove(u(), f);
  }, [f, s]);
  r.useEffect(() => () => {
    c();
  }, [c]), r.useEffect(() => {
    l ? P() : (!g || !p) && c();
  }, [l, c, g, p, P]);
  const F = (n) => (e) => {
    var t;
    (t = n.onKeyDown) == null || t.call(n, e), !(e.key !== "Escape" || !R()) && (M || (e.stopPropagation(), d && d(e, "escapeKeyDown")));
  }, O = (n) => (e) => {
    var t;
    (t = n.onClick) == null || t.call(n, e), e.target === e.currentTarget && d && d(e, "backdropClick");
  };
  return {
    getRootProps: (n = {}) => {
      const e = N(o);
      delete e.onTransitionEnter, delete e.onTransitionExited;
      const t = k({}, e, n);
      return k({
        role: "presentation"
      }, t, {
        onKeyDown: F(t),
        ref: T
      });
    },
    getBackdropProps: (n = {}) => {
      const e = n;
      return k({
        "aria-hidden": !0
      }, e, {
        onClick: O(e),
        open: l
      });
    },
    getTransitionProps: () => {
      const n = () => {
        x(!1), h && h();
      }, e = () => {
        x(!0), C && C(), p && c();
      };
      return {
        onEnter: w(n, i?.props.onEnter),
        onExited: w(e, i?.props.onExited)
      };
    },
    rootRef: T,
    portalRef: _,
    isTopModal: R,
    exited: v,
    hasTransition: g
  };
}
export {
  ee as useModal
};
//# sourceMappingURL=useModal.mjs.map
